function reset_system(id, name) {
    var $ = jQuery.noConflict();

    confirm("Weet u zeker dat u het hele systeem wilt resetten?", function() {
        $('body').isLoading('dark');
        location.href = "/resetAll";
    });

    return false;
}